import type { GroupPublic } from '@repo/types/groups';

import { ChevronDownIcon, GlobeIcon, UsersIcon } from 'lucide-react';

import type { PostAudienceValue } from '@/hooks/posts';

import { Avatar, AvatarFallback, AvatarGroup, AvatarGroupButtonMore, AvatarGroupContent, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { getAvatar } from '@/utils/getAvatar/getAvatar';

interface PostAuthorRowProps {
  name: string;
  surname: string;
  avatarURL?: string | null;
  audience: PostAudienceValue;
  onOpenAudience: () => void;
  selectedGroups?: GroupPublic[];
}

export function PostAuthorRow(postAuthorRowProps: PostAuthorRowProps) {
  const { name, surname, avatarURL, audience, onOpenAudience, selectedGroups } = postAuthorRowProps;
  const visibleGroups = selectedGroups?.slice(0, 3) ?? [];
  const extraGroupsCount = selectedGroups && selectedGroups.length > 3 ? selectedGroups.length - visibleGroups.length : 0;

  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <Avatar size={'lg'}>
          <AvatarImage src={getAvatar(avatarURL)} alt={`${name} ${surname}`.trim()} />
          <AvatarFallback>{name?.[0] || surname?.[0] || <UsersIcon />}</AvatarFallback>
        </Avatar>
        <div className="space-y-0.5">
          <p className="text-sm font-medium">
            {name} {surname}
          </p>
          <Button type="button" variant="outline" size="sm" className="h-6 min-h-6 w-fit gap-1 text-xs" onClick={onOpenAudience}>
            {audience === 'public' ? <GlobeIcon className="size-2.5" /> : <UsersIcon className="size-2.5" />}
            {audience === 'public' ? 'Publiczne' : 'Wybrane grupy'}
            <ChevronDownIcon className="size-3" />
          </Button>
        </div>
      </div>
      {audience === 'groups' && visibleGroups.length > 0 && (
        <AvatarGroup>
          <AvatarGroupContent>
            {visibleGroups.map(({ id, name, avatarURL }) => {
              return (
                <Avatar key={id} size={'sm'}>
                  <AvatarImage src={getAvatar(avatarURL)} alt={name} />
                  <AvatarFallback>
                    <UsersIcon />
                  </AvatarFallback>
                </Avatar>
              );
            })}
            {extraGroupsCount > 0 && (
              <AvatarGroupButtonMore type="button" onClick={onOpenAudience}>
                +{extraGroupsCount}
              </AvatarGroupButtonMore>
            )}
          </AvatarGroupContent>
        </AvatarGroup>
      )}
    </div>
  );
}
